import { CSSProperties, useEffect, useRef } from 'react';
import lottie from 'lottie-web';

interface LottieAnimationProps {
  width?: number | string;
  height?: number | string;
  animationData: any;
  shouldAnimate?: boolean;
  loop?: boolean;
  speed?: number;
  color?: string;
  styles?: CSSProperties;
  preserveAspectRatio?: string;
}

const LottieAnimation = ({
  width,
  height,
  animationData,
  shouldAnimate = true,
  loop = false,
  speed = 2,
  color,
  styles,
  preserveAspectRatio = 'xMidYMid meet' // Изменено значение по умолчанию
}: LottieAnimationProps) => {
  const lottieContainer = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (lottieContainer.current) {
      const animation = lottie.loadAnimation({
        container: lottieContainer.current,
        renderer: 'svg',
        loop: loop,
        autoplay: false,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        animationData: animationData,
        rendererSettings: {
          preserveAspectRatio: preserveAspectRatio,
          progressiveLoad: true
        }
      });

      animation.setSpeed(speed);
      if (shouldAnimate) {
        animation.play();
      }

      animation.addEventListener('DOMLoaded', () => {
        const svgElement = lottieContainer.current?.querySelector('svg');
        if (svgElement && color) {
          const paths = svgElement.querySelectorAll('path');
          paths.forEach((path) => {
            path.style.fill = color;
          });
        }
      });

      return () => {
        animation.destroy();
      };
    }
  }, [shouldAnimate, speed, color, preserveAspectRatio]);

  return (
    <div
      ref={lottieContainer}
      style={{ width: width || 200, height: height || 200, ...styles }}
    />
  );
};

export default LottieAnimation;
